import { Node, mergeAttributes } from "@tiptap/core";

export const FlexBoxNode = Node.create({
  name: "flexBox",
  group: "block",
  content: "block*",
  defining: true,

  addAttributes() {
    return {
      style: {
        default: "display: flex; flex-direction: row; gap: 1rem;",
      },
      class: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (node) => {
          if (node instanceof HTMLElement && node.style.display === "flex") {
            return {
              style: node.getAttribute("style"),
              class: node.getAttribute("class"),
            };
          }
          return false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), 0];
  },
});


